import React from "react";
import {Window, WindowActionsBar} from "@progress/kendo-react-dialogs";
import {Button} from "@progress/kendo-react-buttons";
import {DialogProps} from "../DialogProps";
import {
  hasValue,
  NoScrollNumericTextBox,
  DatePickerWithYearSanitizer
} from "@amsanalytics/react-shared-library";
import {FirstPaymentReview} from "../../../utils/firstPaymentReview";

export interface FirstPaymentAndExtraPaymentDialogProps extends DialogProps<void> {
  review: FirstPaymentReview;
  addOnMessage?: string;
}

export default function FirstPaymentAndExtraPaymentDialog(props: FirstPaymentAndExtraPaymentDialogProps) {
  const {review} = props;

  return (
    <Window
      title={review.nonUniformLabel ? `Confirm First Payment Date and ${review.nonUniformLabel} Payments` : 'Confirm First Payment Date'}
      onClose={props.closeDialog}
      width={420}
      height={480}
    >
      <div style={{pointerEvents: "none", display: 'flex', flexDirection: 'column', gap: '8px', padding: '10px'}}>
        <DatePickerWithYearSanitizer
          width={'75%'}
          label={review.firstPaymentLabel}
          value={review.firstPaymentDate}
        />
        <hr style={{width: '100%'}}/>
        {review.deferredPaymentDates.map((date, key) => (
          <DatePickerWithYearSanitizer
            key={key}
            width={'75%'}
            label={`Deferred Down Payment #${key + 1}`}
            value={date}
          />
        ))}
        {review.irregularPayments.map((ip, key) => (
          <div style={{display: 'flex', flexDirection: 'row', gap: '5px'}} key={key}>
            <div style={{flex: 1}}>
              <DatePickerWithYearSanitizer
                width={'100%'}
                label={'Irregular Payment Start Date'}
                value={ip.startDate}
              />
            </div>
            <div style={{flex: 1}}>
              <NoScrollNumericTextBox
                width={'100%'}
                readOnly
                label={`${ip.count} Payment @`}
                spinners={false}
                format={"c2"}
                value={ip.amount}
              />
            </div>
          </div>
        ))}
        {hasValue(props.addOnMessage) && <p style={{marginTop: '10px'}}>{props.addOnMessage}</p>}
      </div>
      <WindowActionsBar>
        <Button onClick={props.closeDialog}>Cancel</Button>
        <Button themeColor="primary" onClick={() => props.accept && props.accept()}>Confirm Dates</Button>
      </WindowActionsBar>
    </Window>
  );
}
